import { create, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { forIn } from 'lodash-es';
const isInject = (item) => typeof item !== 'undefined' && typeof item !== 'string' && 'inject' in item;
const isString = (item) => typeof item === 'string';
const isWidget = (item) => typeof item !== 'undefined' && typeof item !== 'string' && 'widget' in item;
const hasKids = (item) => {
    if (isWidget(item)) {
        return item.kids !== undefined && Array.isArray(item.kids) && item.kids.length > 0;
    }
    return false;
};
const icache = createICacheMiddleware();
const factory = create({ icache }).properties();
export const ResourceParser = factory(({ properties, middleware: { icache } }) => {
    let keyIndex = 0;
    const { topicid, messages, formatting = {}, preformat = false } = properties();
    const resolveFormatting = (str) => {
        forIn(formatting, (value, key) => {
            const regex = new RegExp(`{${key}}`);
            str = str.replace(regex, value);
            console.info(key, ' :', value);
            console.info('Replaced: ', str);
        });
        return str;
    };
    const resolveInject = (tmp) => {
        if (isString(tmp)) {
            return formatting ? resolveFormatting(tmp) : tmp;
        }
        if (isInject(tmp)) {
            const key = tmp.inject;
            const tmpdata = formatting ? resolveFormatting(messages[key]) : messages[key];
            const impdata = JSON.parse(tmpdata);
            return impdata;
        }
        if (hasKids(tmp)) {
            const kids = tmp
                .kids.map((item) => {
                return resolveInject(item);
            })
                .flat();
            if (kids.length > 0) {
                tmp.kids = kids;
            }
        }
        return tmp;
    };
    const data = icache.getOrSet('data', () => {
        let tmp = [];
        const message = topicid in messages ? messages[topicid] : messages.default;
        const jsonstr = preformat ? resolveFormatting(message) : message;
        try {
            tmp = JSON.parse(jsonstr);
        }
        catch (e) {
            console.warn(`json parse error ${e}`, jsonstr);
        }
        return tmp
            .map((item) => {
            return resolveInject(item);
        })
            .flat();
    });
    const instructorish = window.hcstatic.instructorish ?? false;
    const filterData = (dataSet) => {
        for (let i = dataSet.length - 1; i >= 0; i--) {
            const item = dataSet[i];
            if (isWidget(item)) {
                const is_instructor_led = item.is_instructor_led ? item.is_instructor_led : false;
                if (hasKids(item)) {
                    filterData(item.kids);
                }
                if (!instructorish && is_instructor_led) {
                    dataSet.splice(i, 1);
                }
            }
        }
    };
    filterData(data);
    const walkItem = (item) => {
        if (isString(item)) {
            return item;
        }
        if (isWidget(item)) {
            const widget = item.widget;
            const params = item.params ? item.params : {};
            params.key = `${topicid}-${keyIndex}`;
            keyIndex += 1;
            const kids = hasKids(item) ? item.kids.map((kid) => walkItem(kid)) : [];
            return w(widget, params, kids);
        }
        return null;
    };
    return data.map((item) => walkItem(item));
});
